import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { CategoriesModel } from '@domain/entities/categories.model';
import { CategoriesServerModel } from '@domain/entities/categories.model';
import { CategoriesGateway } from '@domain/gateway/categories-gateway';

@Injectable({
    providedIn: 'root',
})
export class CategoryService extends CategoriesGateway {
    private endpoint = 'wp-json/wc/v3/products/categories';

    constructor(private _http: HttpClient) {
        super();
    }

    /**
     * @description Get categories
     * @param params (Optional)
     * @returns Observable of categories entity
     */
    read(params?: HttpParams): Observable<CategoriesServerModel[]> {
        return this._http.get<CategoriesServerModel[]>(
            `${environment.host}${this.endpoint}`,
            {
                params,
            }
        );
    }

    /**
     * @description Create categories
     * @returns Observable of categories entity
     */
    create(form: CategoriesModel): Observable<CategoriesServerModel> {
        return this._http.post<CategoriesServerModel>(
            `${environment.host}${this.endpoint}`,
            form
        );
    }

    /**
     * @description Read a categories
     * @returns Observable of categories entity description
     */
    readById(id: number): Observable<CategoriesServerModel> {
        return this._http.get<CategoriesServerModel>(
            `${environment.host}${this.endpoint}/${id}`
        );
    }

    /**
     * @description Update categories
     * @returns Observable of categories entity
     */
    update(
        id: number,
        form: CategoriesModel
    ): Observable<CategoriesServerModel> {
        return this._http.put<CategoriesServerModel>(
            `${environment.host}${this.endpoint}/${id}`,
            form
        );
    }

    /**
     * @description Delete categories
     * @returns Observable of categories entity
     */
    delete(id: number): Observable<CategoriesServerModel> {
        return this._http.delete<CategoriesServerModel>(
            `${environment.host}${this.endpoint}/${id}?force=true`
        );
    }
}
